import { type PagamentoWithDettaglioDTO } from '@framework/api-client/api/inquiries-compile/schemas/pagamentoWithDettaglioDTO.ts';
import { type Key, useCallback, useMemo, useState } from 'react';

export function useExtendedPaymentsTable() {
  const [expandedKeys, setExpandedKeys] = useState<readonly Key[]>([]);

  /**
   * Ritorna true se il pagamento contiene degli oneri
   * e dunque la riga deve essere espandibile.
   */
  const isRowExpandable = useCallback(
    (record: PagamentoWithDettaglioDTO) =>
      record.id != null && record.oneri != null && record.oneri.length > 0,
    [],
  );

  const toggleRowExpand = useCallback(
    (record: PagamentoWithDettaglioDTO) => {
      if (!isRowExpandable(record)) return;
      const key = record.id!;
      setExpandedKeys(previous =>
        previous.includes(key)
          ? previous.filter(previousKey => previousKey !== key)
          : [...previous, key],
      );
    },
    [isRowExpandable],
  );

  const expandableConfig = useMemo(
    () => ({
      rowExpandable: isRowExpandable,
      expandedRowKeys: expandedKeys,
      onExpandedRowsChange: (keys: readonly Key[]) => setExpandedKeys(keys),
    }),
    [isRowExpandable, expandedKeys],
  );

  return {
    expandedKeys,
    isRowExpandable,
    toggleRowExpand,
    expandableConfig,
  };
}
